<template>
  <div class="exchangeOrder">
    <headerNotice routerName="订单拣货"></headerNotice>
    <!-- 搜索框 -->
    <div class="seach-box">
      <div class="title-wrapper">
        <h2 class="title">
          <i></i>
          <span>筛选查询</span>
        </h2>
      </div>
      <div class="input-wrapper">
        <div>
          <span>兑换人：</span>
          <el-input class="el-search" v-model="userName" placeholder="请输入兑换人名称"></el-input>
        </div>
        <div>
          <span>订单号：</span>
          <el-input class="el-search" v-model="orderCode" placeholder="请输入订单号"></el-input>
        </div>
        <div>
          <span>兑换时间：</span>
          <el-date-picker
            class='date'
            v-model="duration"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
         <div class="option-wrapper">
          <span>订单状态：</span>
          <el-select class='select' v-model="orderStatus" placeholder="全部">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="option-wrapper">
          <span>订单状态：</span>
          <el-select class='select' v-model="printStatus" placeholder="全部">
            <el-option
              v-for="item in printOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <el-button class="search-btn" @click="toSearch">查询</el-button>
      </div>
    </div>
    <!-- 礼品列表 -->
    <div class="gift-list">
      <div class="head">
        <h2 class="title">
          <i></i>
          <span>数据列表</span>
        </h2>
        <!-- <el-button class="search-btn" @click="toAdd">添加</el-button> -->
      </div>
      <!-- 表格 -->
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="orderList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" prop="orderCode" label="订单号"></el-table-column>
        <el-table-column align="center" prop="houseName" label="所属仓库" width="200"></el-table-column>  
        <el-table-column align="center" prop="title" label="礼品名称"></el-table-column>
        <el-table-column align="center" prop="customerUser" label="客户名称"></el-table-column>
        <el-table-column align="center" prop="userName" label="兑换人"></el-table-column>
        <el-table-column align="center" prop="num" label="兑换数量"></el-table-column>
        <el-table-column align="center" prop="integral" label="消费积分"></el-table-column>
        <el-table-column align="center" prop="exchangeTime" label="兑换时间" width="180"></el-table-column>
        <el-table-column align="center" label="订单状态">
          <template slot-scope="scope">{{ shipStatusFilter(scope.row.status) }}</template>
        </el-table-column>
        <el-table-column align="center" label="打印状态" width="180">
          <!-- <template slot-scope="scope">{{ printStatusFilter(scope.row.printStatus) }}</template> -->
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.printStatus"
                active-text="已打印"
                inactive-text="未打印"
                :active-value="2"
                :inactive-value="1"
                @change="updatePrintStatus(scope.row.orderID,scope.row.printStatus)"
              ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              @click.stop="getIntegralOrderDetails(scope.row.orderID)"
              type="text"
              size="small"
            >查看</el-button>
            <!-- <el-button @click="deleteIntegralItem(scope.row.itemID)" type="text" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog width="600px" title="订单详情" :visible.sync="showDetail">
      <div v-loading="dialogLoading" class="list-detail">
        <table>
          <tr v-for="(item,index) in orderDetails" :key="index">
            <td>{{item.name}}</td>
            <td>{{item.val}}</td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 多选操作 -->
    <div style="margin-top: 20px; margin-left: 50px">
      <el-button :loading="btnLoading" @click="bulkShipment">发货确认</el-button>
      <!-- <el-button :loading="btnLoading" @click="toPrintShip">打印快递单</el-button> -->
      <el-button :loading="btnLoading" @click="printElectronicSheet">打印电子面单</el-button>
    </div>
    <!--分页-->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync='currentPage'
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        center
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  components: {
    headerNotice
  },
  props: {},
  data() {
    return {
      loading: false,
      btnLoading: false,
      dialogLoading: false,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      showDetail: false,
      userName: "",
      orderCode: "",
      duration: [],
      orderList: [],
      orderDetails: [],
      multipleSelection: [],
      options: [
        { value: 0, label: "全部" },
        { value: 1, label: "待发货" },
        { value: 2, label: "待收货" },
        // { value: 3, label: "已完成" }
      ],
      orderStatus: 0,
      printOption: [
        { value: 0, label: "全部" },
        { value: 1, label: "未打印" },
        { value: 2, label: "已打印" },
      ],
      printStatus: 0
    };
  },
  watch: {
    duration(val) {
      if(!val) {
        this.duration = []
      }
    }
  },
  computed: {},
  methods: {
    toSearch() {
      let params = {
        CreateTime: this.duration[0],
        CreateTimes: this.duration[1],
        userName: this.userName,
        orderCode: this.orderCode,
        Status: this.orderStatus,
        PrintStatus: this.printStatus,
        MaxResultCount: this.pageSize,
        SkipCount: 0
      };
      this.getAdminOrder(params);
      this.currentPage = 1
    },
    // 获取订单详情
    getIntegralOrderDetails(id) {
      let params = {
        OrderID: id
      };
      let self = this;
      self.showDetail = true;
      self.dialogLoading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetIntegralOrderDetails",
        params: params,
        success(res) {
          // console.log(res);
          if(res.length) {
            self.orderDetails = [
              {name: '订单编号', val: res[0].orderCode},
              {name: '兑换时间', val: res[0].createtime},
              {name: '订单状态', val: self.shipStatusFilter(res[0].status)},
              {name: '快递公司', val: res[0].logistics},
              {name: '快递单号', val: res[0].expressNo},
              {name: '打印状态', val: self.printStatusFilter(res[0].printStatus)},
              {name: '礼品名称', val: res[0].title},
              {name: '消费积分', val: res[0].subtotal},
              {name: '兑换数量', val: res[0].exchangeNum},
              {name: '客户名称', val: res[0].customer},
              {name: '兑换人', val: res[0].recipient},
              {name: '联系电话', val: res[0].phone},
              {name: '收货地址', val: res[0].site} 
            ]
          } else {
            self.orderDetails = [
              {name: '订单编号', val: ''},
              {name: '兑换时间', val: ''},
              {name: '订单状态', val: ''},
              {name: '快递公司', val: ''},
              {name: '快递单号', val: ''},
              {name: '打印状态', val: ''},
              {name: '礼品名称', val: ''},
              {name: '消费积分', val: ''},
              {name: '兑换数量', val: ''},
              {name: '客户名称', val: ''},
              {name: '兑换人', val: ''},
              {name: '联系电话', val: ''},
              {name: '收货地址', val: ''} 
            ]
          }
          
          self.dialogLoading = false;
        },
        fail(res) {
          self.dialogLoading = false;
        }
      });
    },
    // 切换打印状态
    updatePrintStatus (id, status) {
      let self = this;
      let search = `?OrderID=${id}&PrintStatus=${status}`
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/IntegralUpPrintStatus" + search,
        // data: {
        //   OrderID: id,
        //   PrintStatus: status
        // },
        success(res) {
          self.$message.success('操作成功')
        },
        fail(res) {
          // self.loading = false;
        }
      });
    },
    //批量发货确定
    bulkShipment() {
      let self = this;
      if (this.multipleSelection.length) {
        let orderIDArr = [];
        let count = 0
        self.multipleSelection.forEach((ele, index) => {
          orderIDArr.push(ele.orderID);
          if(ele.status == 1) count++
        });
        if(!count) {
          self.$message.error('无待发货订单')
          return
        } else {
          self.$message.success(`已选择${count}笔待发货订单`)
        }
        sessionStorage.setItem("orderIDArr", orderIDArr);
        this.$router.push({
          path: "/exchangeShipment"
        });
      } else {
        this.$message.error("请先勾选要发货的订单！");
        return;
      }
    },
    //批量打印电子面单
    printElectronicSheet() {
      let self = this;
      if (this.multipleSelection.length) {
        let orderIDArr = [];
        let count = 0
        self.multipleSelection.forEach((ele, index) => {
          if(ele.status == 2) {
            orderIDArr.push(ele.orderID);
            count++
          }
        });
        if(!count) {
          self.$message.error('无待收货订单')
          return
        } else {
          self.$message.success(`已选择${count}笔待收货订单`)
        }
        sessionStorage.setItem("orderIDArr", orderIDArr);
        this.$router.push({
          path: "/exchangeElectronicSheet"
        });
      } else {
        this.$message.error("请先勾选要打印的订单！");
        return;
      }
    },
    //获取礼品列表
    getAdminOrder(params) {
      let self = this;
      self.loading = true;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminIntegralExchange/GetAdminASinglePicking",
        params: params,
        success(res) {
          // console.log(res);
          self.orderList = res.items;
          self.totalCount = res.totalCount;
          self.loading = false;
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //一页显示多少个
    handleSizeChange(val) {
      this.maxResultCount = val;
      let params = {
        CreateTime: this.duration[0],
        CreateTimes: this.duration[1],
        userName: this.userName,
        orderCode: this.orderCode,
        Status: this.orderStatus,
        MaxResultCount: val
      };
      this.getAdminOrder(params);
    },
    //跳转到指定页
    handleCurrentChange(val) {
      let skipCount = (val - 1) * this.pageSize;
      let params = {
        CreateTime: this.duration[0],
        CreateTimes: this.duration[1],
        userName: this.userName,
        orderCode: this.orderCode,
        Status: this.orderStatus,
        SkipCount: skipCount,
        MaxResultCount: this.pageSize
      };
      this.getAdminOrder(params);
    },
    shipStatusFilter(status) {
      return status == 1 ? "待发货" : (status == 2 ? "待收货" : "已完成");
    },
    printStatusFilter(status) {
      let text = "";
      switch (status) {
        case 1:
          text = "未打印";
          break;
        case 2:
          text = "已打印";
          break;
        default:
          text = status;
      }
      return text;
    }
  },
  created() {
    this.getAdminOrder({
      MaxResultCount: this.pageSize,
      Status: this.orderStatus
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.exchangeOrder {
  // 搜索
  .seach-box {
    border: 1px solid rgba(228, 228, 228, 1);
    margin: 20px 50px;
    .title-wrapper {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      height: 50px;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 20px;
    }
    .title {
      display: flex;
      height: 50px;
      align-items: center;
      font-weight: 400;
      // i:first-child {
      //   width: 18px;
      //   height: 18px;
      //   background: green;
      // }
    }
    .input-wrapper {
      display: flex;
      align-items: center;
      height: 100px;
      padding-left: 20px;
      .el-search {
        width: 160px;
      }
      .date {
        width: 260px;
      }
      .select {
        width: 150px;
      }
      // .option-wrapper {
      //   margin-left: 40px;
      // }
      // .option-wrapper:last-of-type {
      //   margin-right: 40px;
      // }
      // div:first-child {
      //   margin-right: 20px;
      // }
      // div:nth-of-child(2) {
      //   margin-right: 20px;
      // }
      div {
        margin-right: 10px;
      }
    }
  }

  // 礼品列表
  .gift-list {
    margin: 0 50px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-weight: 400;
    .head {
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      background-color: rgba(243, 243, 243, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding-right: 20px;
      .title {
        display: flex;
        align-items: center;
        height: 50px;
        font-weight: 400;
        padding-left: 20px;
        // i:first-child {
        //   width: 18px;
        //   height: 18px;
        //   background: green;
        // }
      }
    }
  }
  .pagination-wrapper {
    text-align: center;
    margin-top: 20px;
  }
  .list-detail {
    td {
      height: 40px;
      width: 470px;
      padding: 5px 10px;
      border: 1px solid #e4e4e4;
      border-collapse: collapse;
      word-break: break-all;
      &:first-child {
        width: 120px;
        padding: 0;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
}
</style>